import { Component, OnInit } from '@angular/core';
import { NavBarComponent } from '../../nav-bar/nav-bar.component';
import { VendorService } from '../../vendor-portal/vendor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { QuickDialog } from '../../utilities/Dialog/QuickDialog';
import { MatDialog, MatSlideToggleChange } from '@angular/material';
import { FormUtils } from '../../utilities/FormUtils/FormUtils';

@Component({
  selector: 'app-courier-onboarding',
  templateUrl: './courier-onboarding.component.html',
  styleUrls: ['./courier-onboarding.component.css']
})
export class CourierOnboardingComponent implements OnInit {

  step = 1;
  selectedFile;
  navOptions = NavBarComponent.standard;
  form: FormGroup;
  clientinfo: any = {}
  constructor(private router: Router, private dialog: MatDialog, private vendor: VendorService, private route: ActivatedRoute, private formBuilder: FormBuilder,) {
    this.form = this.formBuilder.group({
      id:[null,[]],
      name: [null, [Validators.required]],
      url: [null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9-]+$/)]]
    });
  }

  ngOnInit() {
    this.loadInfo()
  }

  getClass(name) {
    if (this.isFieldInvalid(name)) {
      return 'form-control round-input error-border';
    } else {
      return 'form-control round-input';
    }
  }

  isFieldInvalid(name: string): boolean {
    var field = this.form.get(name);
    if (field.invalid && field.touched) {
      return true;
    }
    return false;
  }

    onPercentage(event: MatSlideToggleChange){
      if(event.source.checked){
        this.clientinfo.settings.driverPay.fixed.enabled = false;
      }
    }
  
    onFixed(event: MatSlideToggleChange){
      if(event.source.checked){
        this.clientinfo.settings.driverPay.percentage.enabled = false;
      }
    }


  loadInfo(patch = true) {
    this.vendor.getVendorInfoById(this.route.snapshot.queryParams.cid).then((res) => {
      this.clientinfo = res.data;
      if (patch) {
        this.form.patchValue({
          id: this.clientinfo.id,
          name: this.clientinfo.name,
          url: this.clientinfo.url ? this.clientinfo.url : this.formatUrl(this.clientinfo.name)
        })
      }
    }).catch(e => {
      console.log(e);
    })
  }

  formatUrl(input) {
    return input.trim().toLowerCase().replace(/\s+/g, '-');
  }

  onFileSelected(event) {
    const file = event.target.files[0];
    if (file) {
      const maxSizeInBytes = 1 * 1024 * 1024; // 3MB

      if (file.size > maxSizeInBytes) {
        new QuickDialog(this.dialog).InfoDialog("The file should not exceed 3 megabytes. Try reducing the file size then upload again.", "File Too Large", "OK");
        return;
      }
      this.selectedFile = file;
    }
    if (!this.selectedFile) {
      alert('Please select a file first.');
      return;
    }

    const formData = new FormData();
    formData.append('id', this.clientinfo.id);
    formData.append('file', this.selectedFile);
    var d = new QuickDialog(this.dialog).LoadingDialog("Uploading....");
    this.vendor.setLogo(formData).then((res) => {
      d.close();
      this.loadInfo(false);
    }).catch(e => {
      d.close();
      new QuickDialog(this.dialog).InfoDialog("There was an issue uploading your logo. Please try again later", "Unable to upload", "Ok");
    })

  }

  saveAll() {
    var d = new QuickDialog(this.dialog).LoadingDialog("Please wait...");
    this.vendor.updateClientSettings(this.clientinfo.settings).then((res) => {
      d.close();
      new QuickDialog(this.dialog).InfoDialog("Your account has been set up. You will now be redirected to set a password and login.", "All Set", "OK").then(() => {
        this.router.navigate(['admin-portal/login'], { queryParams: { reset: 1 } });
      })
    }).catch(e => {
      d.close();
      new QuickDialog(this.dialog).InfoDialog("We were unable to finish setting up your account. Please contact support if the issue persists.", "We're Sorry", "OK");
    });
  }

  saveNext(){
    FormUtils.markFormGroupTouched(this.form);
    if(this.form.valid){
      var d = new QuickDialog(this.dialog).LoadingDialog("Please wait...");
      this.vendor.updateDbSettings(this.form.getRawValue()).then((res) =>{
        d.close();
        this.next();
      }).catch(e =>{
        d.close();
        new QuickDialog(this.dialog).InfoDialog("We were unable to save this information. Please contact support if the issue persists.", "We're Sorry", "OK");
      })
    }
  }

  next() {
    this.step += 1;
  }
  prev() {
    this.step -= 1;
  }

}
